export default "__VITE_ASSET__CC$qy0VF__"